export const mode = ['None', 'Road', 'Rail', 'Air', 'Ship'];
